import React from 'react'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Toasts() {
  return <ToastContainer pauseOnHover={false}/>
}